"use client";

import { Button, buttonVariants } from "@/components/ui/button";
import { MultidietPickerPopup } from "@/features/multidiet-picker/components/multidiet-picker-popup";
import React, { useState } from "react";

export const HeroLandingCta = ({ label }: { label: string }) => {
  const [open, setOpen] = useState(false);

  const handleOpenMultiDietPopup = () => {
    setOpen(true);
  };

  return (
    <MultidietPickerPopup setOpen={setOpen} open={open}>
      <Button
        onClick={handleOpenMultiDietPopup}
        className={buttonVariants({
          variant: "secondary",
          size: "wide",
          className: "text-brand-green1-300",
        })}
      >
        {label}
      </Button>
    </MultidietPickerPopup>
  );
};
